import React from 'react';

import './NonExistantDatasetsPrinting.scss';
import T from 'services/lang/LanguageService';

type NonExistantDatasetsPrintingProps = {
    datasetsArray: Array<string>
}

const NonExistantDatasetsPrinting = (props: NonExistantDatasetsPrintingProps) => {
    return (
        <div className="main-frame">
            <div className="non-main-frame">
                <div className="font-style">{T("message.following-datasets-were-not-found")}</div>
                    {
                        props.datasetsArray.map((ob, i) => {
                            return <div className="table-row" key={i}>
                                {ob}
                            </div>
                        })
                    }
            </div>
        </div>
    );
}

export default NonExistantDatasetsPrinting;